import { combineReducers } from 'redux';

import { EXPORT_TYPES_REQUEST, EXPORT_TYPES_RECEIVE, EXPORT_TYPES_ERROR } from '../actions/export-types';

export default (state = {}, action) => {

    const isFetching = (state = false, action) => {
        switch (action.type) {
            case EXPORT_TYPES_REQUEST:
                return true;
            case EXPORT_TYPES_RECEIVE:
            case EXPORT_TYPES_ERROR:
                return false;
            default:
                return state;
        }
    };

    const valid = (state = false, action) => {
        switch (action.type) {
            case EXPORT_TYPES_RECEIVE:
                return true;
            default:
                return state;
        }
    };

    const items = (state = [], action) => {
        switch (action.type) {
            case EXPORT_TYPES_RECEIVE:
                return action.payload;
            default:
                return state;
        }
    };

    return combineReducers({
        isFetching,
        valid,
        items
    })(state, action);
}